// biome-ignore lint/suspicious/noExplicitAny: jquery
declare let $: any

export class VideoInternal {
	el: Element

	constructor(el) {
		this.el = el
		this.init()
	}

  init() {
    const overlay = this.el.querySelector<HTMLButtonElement>('.video-overlay');
    const video = this.el.querySelector<HTMLVideoElement>('video');
                    
    if (overlay && video) {
        // Initially hide controls
        video.controls = false;
        
        overlay.addEventListener('click', (event) => {
            event.preventDefault();
            // Show controls
            video.controls = true;
            // Play video
            video.play();
            // Hide overlay
            overlay.classList.add('hidden');
        });

        video.addEventListener('pause', () => {
            overlay.classList.remove('hidden');
            video.controls = false;
        });
    }
  }

}